/* magnify-hover.js
   Lupa 2x dentro del lightbox de producto: una vez abierto el modal
   (clic en la imagen), al mover el ratón sobre una imagen se muestra
   una vista ampliada de esa zona siguiendo el cursor.
   Solo escritorio (hover + pointer: fine); en táctil no hace nada.
   Estilos del overlay en .image-magnify-lens (section-main-product.css). */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var ZOOM_RATIO = 2;

  function setupMagnify(image) {
    if (image.dataset.magnifyHover) return;
    image.dataset.magnifyHover = 'true';

    var dialog = image.closest('.product-media-modal__dialog');
    var content = image.closest('.product-media-modal__content');
    if (!dialog || !content) return;

    var lens = null;

    function createLens() {
      lens = document.createElement('div');
      lens.className = 'image-magnify-lens';
      lens.setAttribute('aria-hidden', 'true');
      lens.style.backgroundImage = "url('" + image.src + "')";
      dialog.appendChild(lens);
    }

    function removeLens() {
      if (lens) {
        lens.remove();
        lens = null;
      }
    }

    function moveLens(event) {
      if (!lens) createLens();
      var rect = image.getBoundingClientRect();
      lens.style.left = rect.left + 'px';
      lens.style.top = rect.top + 'px';
      lens.style.width = rect.width + 'px';
      lens.style.height = rect.height + 'px';
      var xPercent = ((event.clientX - rect.left) / rect.width) * 100;
      var yPercent = ((event.clientY - rect.top) / rect.height) * 100;
      lens.style.backgroundSize = rect.width * ZOOM_RATIO + 'px auto';
      lens.style.backgroundPosition = xPercent + '% ' + yPercent + '%';
    }

    image.addEventListener('mousemove', moveLens);
    image.addEventListener('mouseleave', removeLens);
    // si se hace scroll en el modal, el rect cambia: quitar la lupa
    content.addEventListener('scroll', removeLens);
  }

  document.querySelectorAll('.product-media-modal__content img').forEach(setupMagnify);
})();
